export interface SettingsCompanyRouter {
  goToCompanySettings(): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SettingsCompanyRouter = Symbol('SettingsCompanyRouter');
